var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.statusChange },
              model: {
                value: _vm.activeStatus,
                callback: function ($$v) {
                  _vm.activeStatus = $$v
                },
                expression: "activeStatus",
              },
            },
            _vm._l(_vm.tabs, function (tab) {
              return _c("el-tab-pane", {
                key: tab.value,
                attrs: {
                  name: tab.value,
                  label: tab.label + " " + (_vm.counts[tab.countKey] || 0),
                },
              })
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "订单号、商品、姓名或手机号",
                  size: "small",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.load($event)
                  },
                },
                model: {
                  value: _vm.query.keyword,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.query,
                      "keyword",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "query.keyword",
                },
              }),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    placeholder: "履约方式",
                    size: "small",
                  },
                  model: {
                    value: _vm.query.deliveryType,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "deliveryType", $$v)
                    },
                    expression: "query.deliveryType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "到店核销", value: 1 } }),
                  _c("el-option", { attrs: { label: "快递发货", value: 2 } }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: { click: _vm.load },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["distribution:store:order:verify"],
                      expression: "['distribution:store:order:verify']",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-s-check" },
                  on: { click: _vm.openVerify },
                },
                [_vm._v("订单核销")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.rows, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单号", "min-width": "185" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品", "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "product-cell" },
                          [
                            _c("el-image", {
                              staticClass: "thumb",
                              attrs: { src: scope.row.productImage },
                            }),
                            _c("div", [
                              _vm._v(_vm._s(scope.row.productName)),
                              _c("div", { staticClass: "muted" }, [
                                _vm._v(_vm._s(scope.row.sku)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "用户", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.realName || "-"))]),
                        _c("span", { staticClass: "muted" }, [
                          _vm._v(_vm._s(scope.row.userPhone)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "payNum", label: "数量", width: "70" },
              }),
              _c("el-table-column", {
                attrs: { prop: "payPrice", label: "实付", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "履约", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.deliveryType === 1
                              ? "到店核销"
                              : "快递发货"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "statusName", label: "状态", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "下单时间",
                  "min-width": "155",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "190", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        scope.row.status === 1 && scope.row.deliveryType === 2
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: [
                                      "distribution:store:order:delivery",
                                    ],
                                    expression:
                                      "['distribution:store:order:delivery']",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDelivery(scope.row)
                                  },
                                },
                              },
                              [_vm._v("发货")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["distribution:store:order:remark"],
                                expression:
                                  "['distribution:store:order:remark']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openRemark(scope.row)
                              },
                            },
                          },
                          [_vm._v("备注")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.query.page,
              "page-size": _vm.query.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next",
              "page-sizes": [10, 20, 50],
            },
            on: {
              "current-change": _vm.pageChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单核销",
            visible: _vm.verifyVisible,
            width: "460px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.verifyVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "核销码" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "64" },
                    model: {
                      value: _vm.verifyCode,
                      callback: function ($$v) {
                        _vm.verifyCode =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "verifyCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.verifyVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.verify },
                },
                [_vm._v("确认核销")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "快递发货",
            visible: _vm.deliveryVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deliveryVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.actionForm, "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "快递公司" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.actionForm.expressName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.actionForm,
                          "expressName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "actionForm.expressName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "快递单号" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.actionForm.expressNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.actionForm,
                          "expressNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "actionForm.expressNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deliveryVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.delivery },
                },
                [_vm._v("确认发货")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单备注",
            visible: _vm.remarkVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.remarkVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 4,
              maxlength: "500",
              "show-word-limit": "",
            },
            model: {
              value: _vm.actionForm.remark,
              callback: function ($$v) {
                _vm.$set(
                  _vm.actionForm,
                  "remark",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "actionForm.remark",
            },
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.remarkVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.remark },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单详情",
            visible: _vm.detailVisible,
            width: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.detail
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                    _vm._v(_vm._s(_vm.detail.orderNo)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                    _vm._v(_vm._s(_vm.detail.statusName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "商品" } }, [
                    _vm._v(_vm._s(_vm.detail.productName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "规格" } }, [
                    _vm._v(_vm._s(_vm.detail.sku || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "实付" } }, [
                    _vm._v("¥" + _vm._s(_vm.detail.payPrice)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "数量" } }, [
                    _vm._v(_vm._s(_vm.detail.payNum)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "积分抵扣" } }, [
                    _vm._v(
                      _vm._s(
                        Number(_vm.detail.integralPrice) > 0
                          ? "-¥" +
                              _vm.detail.integralPrice +
                              "（" +
                              _vm.detail.useIntegral +
                              "积分）"
                          : "-"
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "优惠券" } }, [
                    _vm._v(
                      _vm._s(
                        Number(_vm.detail.couponPrice) > 0
                          ? "-¥" + _vm.detail.couponPrice
                          : "-"
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "收货人" } }, [
                    _vm._v(_vm._s(_vm.detail.realName || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "手机" } }, [
                    _vm._v(_vm._s(_vm.detail.userPhone || "-")),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "地址", span: 2 } },
                    [_vm._v(_vm._s(_vm.detail.userAddress || "-"))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "快递" } }, [
                    _vm._v(_vm._s(_vm.detail.expressName || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "快递单号" } }, [
                    _vm._v(_vm._s(_vm.detail.expressNo || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "核销码" } }, [
                    _vm._v(_vm._s(_vm.detail.verifyCode || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "核销时间" } }, [
                    _vm._v(_vm._s(_vm.detail.verifyTime || "-")),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }